import React from 'react';
import ReactECharts from 'echarts-for-react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp } = FiIcons;

const months = ['Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan'];
const sentData = [12, 18, 22, 19, 28, 34];
const openedData = [8, 13, 17, 14, 22, 28];
const clickedData = [3, 6, 9, 7, 12, 15];

const NotificationTrendChart = () => {
  const option = {
    tooltip: { trigger: 'axis', formatter: p => p.map(s => `${s.marker}${s.seriesName}: <b>${s.value}</b>`).join('<br/>') },
    legend: { data: ['Sent', 'Opened', 'Clicked'], bottom: 0, textStyle: { fontSize: 11 } },
    grid: { left: '3%', right: '4%', bottom: '18%', top: '5%', containLabel: true },
    xAxis: { type: 'category', data: months, axisLabel: { fontSize: 11 }, axisLine: { lineStyle: { color: '#e2e8f0' } } },
    yAxis: { type: 'value', splitLine: { lineStyle: { color: '#f1f5f9' } }, axisLabel: { fontSize: 10 } },
    series: [
      { name: 'Sent', type: 'bar', data: sentData, itemStyle: { color: '#3b82f6', borderRadius: [4, 4, 0, 0] }, barMaxWidth: 20 },
      { name: 'Opened', type: 'bar', data: openedData, itemStyle: { color: '#10b981', borderRadius: [4, 4, 0, 0] }, barMaxWidth: 20 },
      { name: 'Clicked', type: 'bar', data: clickedData, itemStyle: { color: '#f59e0b', borderRadius: [4, 4, 0, 0] }, barMaxWidth: 20 },
    ],
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center gap-2 mb-4">
        <SafeIcon icon={FiTrendingUp} className="text-blue-500" />
        <h3 className="text-sm font-semibold text-slate-700">Notification Engagement Trend</h3>
      </div>
      <ReactECharts option={option} style={{ height: 240 }} />
    </div>
  );
};

export default NotificationTrendChart;